import React from "react";
import { useRouter } from "next/router";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Link from "@insightfulscience/atomic-react/Link";
import routes from "../../routes";
import ErrorLayout from "./ErrorLayout";

function Error401() {
	const { asPath } = useRouter();

	return (
		<ErrorLayout>
			<Heading Tag="h1" size="xl" center className="mb-6 text-color-3">
				Not Authorized
			</Heading>
			<Paragraph size="s" center className="">
				We’re sorry. You are not authorized to access the requested resource.
				<br />
				<br />
				Please{" "}
				<Link
					href={`${routes.signIn.url}?returnUrl=${encodeURIComponent(asPath)}`}
					size="s"
				>
					sign in
				</Link>{" "}
				with a different account, or{" "}
				<Link href={routes.external.help} size="s">
					contact us
				</Link>{" "}
				for further assistance.
			</Paragraph>
		</ErrorLayout>
	);
}

export default Error401;
